import React, { Component } from 'react';
import { Label, Button } from 'semantic-ui-react';
//import 'semantic-ui-css/semantic.min.css';
import { ajaxPost } from '../ajax';

class NotificationBell extends Component {
    state =
        {
            unread: 0
        }

    componentWillMount = () => {
        // Initial check to get current unread count
        this.checkNotifications();

        // Setup SignalR listener for real-time updates
        this.setupSignalRListener();
    }

    componentWillUnmount = () => {
        // Clean up SignalR listener
        if (this.signalRCleanup) {
            this.signalRCleanup();
        }
    }

    setupSignalRListener = () => {
        // Register notification handler
        if (global.SignalRConnection && global.SignalRConnection.state === "Connected") {
            // Use global.userId set in navigate.js after session check
            const userId = global.userId;
            // Fallback to SessionId if for some reason global.userId is missing (legacy support)
            const idToUse = userId || global.sessionId;
            const eventName = `userId:${idToUse}`;

            // console.log('[NotificationBell] Registering handler for channel:', eventName);

            const handleNotification = (dataStr) => {
                try {
                    const data = JSON.parse(dataStr);
                    // console.log('[NotificationBell] Received notification:', data);

                    // Handle different notification types
                    if (data.Type === "NewNotification") {
                        // console.log('[NotificationBell] Processing NewNotification, UnreadCount:', data.UnreadCount);
                        // Update unread count from server (more accurate than incrementing)
                        if (data.UnreadCount !== undefined) {
                            this.setState({ unread: data.UnreadCount });
                        } else {
                            // Fallback to increment if UnreadCount not provided
                            this.setState(prevState => ({ unread: prevState.unread + 1 }));
                        }
                    } else if (data.Type === "NotificationRead" || data.Type === "AllNotificationsRead") {
                        // Update unread count from server
                        this.setState({ unread: data.UnreadCount });
                    }
                } catch (error) {
                    console.error("[NotificationBell] Error processing notification:", error);
                }
            };

            global.SignalRConnection.on(eventName, handleNotification);
            // console.log('[NotificationBell] Handler registered successfully');

            // Store cleanup function
            this.signalRCleanup = () => {
                global.SignalRConnection.off(eventName, handleNotification);
            };
        } else {
            // Retry after 1 second if connection not ready
            console.log('[NotificationBell] SignalR not ready, retrying in 1 second...');
            setTimeout(this.setupSignalRListener, 1000);
        }
    }

    // Initial check only - no recurring polling
    checkNotifications = () => {
        // console.log('[NotificationBell] Fetching initial unread count...');
        var searchParameter =
        {
            data: [],
            updateSession: false,
            url: "api/Notification/check",
            onError: (error) => {
                console.error('[NotificationBell] Error fetching initial count:', error);
            },
            onSuccess: (data, sender) => {
                // console.log('[NotificationBell] Initial unread count:', data.TotalUnread);
                this.setState({ unread: data.TotalUnread });
            },
            finally: () => {
                // No recurring polling - SignalR handles updates
            }
        };
        ajaxPost(searchParameter);
    };


    render() {
        return (
            <div style={{ display: "inline-block", position: "relative", alignSelf: "center" }}>
                <Button
                    id="btnNotification"
                    circular
                    icon="bell"
                    size="large"
                    onClick={this.props.onClick}
                    inverted
                />
                {this.state.unread > 0 && (
                    <Label
                        style={{ zIndex: 0 }}
                        id="lblNotification"
                        size="tiny"
                        color="red"
                        floating
                        circular
                    >
                        {this.state.unread.toString()}
                    </Label>
                )}
            </div>
        )
    }
}

export default NotificationBell;